/* eslint-disable no-undef */
export default {
	name: "zone-pricing-for-customer-add-update-table",
	props: ["customerZonePricing", "product", "clearTable", "orderTypeId"],
	emits: ["zoneSelected"],
	data() {
		return {
			zonesPricing: [],
			shippingAddresses: [],
			customerHasNoShippingAddresses: false,
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			filter:{
				searchQuery: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			orderTotal: 0,
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false,
			precision: 2,
			showExTank: false
		};
	},
	methods: {
		getShippingAddresses(){
			var orderTypeId = this.orderTypeId === null || this.orderTypeId === undefined ? orderHelper.orderType.delivery : this.orderTypeId;
			let request = {
				//companyId: this.companyId,
				productId: this.product.productId,
				orderTypeId: orderTypeId
			};
			console.log("customerZonePricing", this.customerZonePricing);
			productService.getZoneProductBasePricesWithShippingAddresses(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.shippingAddresses = successResponse.data.result;
						if(this.shippingAddresses === null || this.shippingAddresses.length === 0){
							this.customerHasNoShippingAddresses = true;
						}
						else{
							this.customerHasNoShippingAddresses = false;
						}
						for(let i = 0; i < this.shippingAddresses.length; i++){
							this.shippingAddresses[i].selected = false;
							if(this.orderTypeId === orderHelper.orderType.exTank) {
								this.shippingAddresses[i].priceBeforeDiscountAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.shippingAddresses[i].price);
							}
							else{
								this.shippingAddresses[i].priceBeforeDiscountAsString = currencyHelper.numberToCurrency(this.shippingAddresses[i].price);
							}
							this.shippingAddresses[i].discountAmount = null;
							this.shippingAddresses[i].priceAfterDiscount = null;
							this.shippingAddresses[i].customerZonePricingId = 0;
							if(this.customerZonePricing !== null){
								for(let j = 0; j < this.customerZonePricing.length; j++){
									if(this.customerZonePricing[j].companyAddressId === this.shippingAddresses[i].companyAddressId){
										//this.shippingAddresses[i].price = this.customerZonePricing[j].basePrice;
										this.shippingAddresses[i].priceAfterDiscount = this.shippingAddresses[i].price - this.customerZonePricing[j].discountAmount;
										if(this.orderTypeId === orderHelper.orderType.exTank){
											this.shippingAddresses[i].priceBeforeDiscountAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.shippingAddresses[i].price);
											this.shippingAddresses[i].priceAfterDiscountAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.shippingAddresses[i].priceAfterDiscount);
										}
										else{
											this.shippingAddresses[i].priceBeforeDiscountAsString = currencyHelper.numberToCurrency(this.shippingAddresses[i].price);
											this.shippingAddresses[i].priceAfterDiscountAsString = currencyHelper.numberToCurrency(this.shippingAddresses[i].priceAfterDiscount);
										}
										this.shippingAddresses[i].customerZonePricingId = this.customerZonePricing[j].companyShippingAddressPriceId;
										this.shippingAddresses[i].discountAmount = this.customerZonePricing[j].discountAmount;
										this.shippingAddresses[i].isActive = this.customerZonePricing[j].isActive;
										break;
									}
								}
							}
						}
						//this.shippingAddresses = dataTableHelper.castFieldValues(this.shippingAddresses);
						console.log("shippingAddresses", this.shippingAddresses);
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onAmountChange(shippingAddress){
			console.log("amount change");
			shippingAddress.priceAfterDiscount = shippingAddress.price - shippingAddress.discountAmount;
			if(this.orderTypeId === orderHelper.orderType.exTank){
				shippingAddress.priceAfterDiscountAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(shippingAddress.priceAfterDiscount);
			}
			else{
				shippingAddress.priceAfterDiscountAsString = currencyHelper.numberToCurrency(shippingAddress.priceAfterDiscount);
			}
		},
		onZoneSelect(){
			let selectedZones = [];
			for(let i = 0; i < this.shippingAddresses.length; i++){
				if(this.shippingAddresses[i].selected){
					if(this.shippingAddresses[i].discountAmount !== null)
					{
						selectedZones.push(this.shippingAddresses[i]);
					}
				}
			}
			if(selectedZones.length > 0){
				this.$emit("zoneSelected", selectedZones);
			}
			
		}
	},
	mounted: function () {
	},
	watch:{
		// companyId:{
		// 	handler: function (){
		// 		console.log("companyId", this.companyId);
		// 		// if(this.companyId && this.product){
		// 		// 	this.getShippingAddresses();
		// 		// }
        //         if(this.companyId){
        //             this.getShippingAddresses();
        //         }
		// 	},
		// 	immediate: true,
		// 	deep: true
		// },
		product:{
			handler: function (){
				if(this.product){
					this.getShippingAddresses();
				}
			},
			immediate: true,
			deep: true
		},
		clearTable:{
			handler: function (){
				if(this.clearTable){
					this.shippingAddresses = [];
				}
			},
			immediate: true,
			deep: true
		},
		orderTypeId:{
			handler: function (){
				if(this.orderTypeId !== null && this.orderTypeId !== undefined){
					if(this.orderTypeId === orderHelper.orderType.exTank){
						this.precision = 4;
						this.showExTank = true;
                        //this.getShippingAddresses();
					}
				}
			},
			immediate: true,
			deep: true
		}
	}
};
